/**
 * Route-level Error Boundary for page-level error handling
 */

import { Component, ErrorInfo, ReactNode } from 'react'
import { ErrorBoundary } from './ErrorBoundary'

interface RouteErrorBoundaryProps {
  children: ReactNode
  routeName: string
}

export class RouteErrorBoundary extends Component<RouteErrorBoundaryProps> {
  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // Log route-specific errors
    console.error(`Error in route: ${this.props.routeName}`, error, errorInfo)
  }

  render(): ReactNode {
    return (
      <ErrorBoundary
        fallback={
          <div className="min-h-screen flex items-center justify-center bg-background px-4">
            <div className="max-w-md w-full bg-card rounded-lg shadow-lg p-6 border border-border">
              <h2 className="text-2xl font-bold text-foreground mb-4">
                Lỗi trong trang {this.props.routeName}
              </h2>
              <p className="text-muted-foreground mb-4">
                Đã xảy ra lỗi khi tải trang này. Vui lòng thử lại sau.
              </p>
              <button
                onClick={() => window.location.reload()}
                className="btn-primary w-full"
              >
                Tải lại trang
              </button>
            </div>
          </div>
        }
      >
        {this.props.children}
      </ErrorBoundary>
    )
  }
}

